import type { TourDefinition } from '../types';

export const chatTour: TourDefinition = {
  id: 'chat',
  title: 'Atendimento',
  steps: [
    {
      element: '[data-tour="chat-conversation-list"]',
      popover: {
        title: 'Lista de Conversas',
        description:
          'Veja todas as conversas do WhatsApp. Conversas não lidas aparecem destacadas.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="chat-thread"]',
      popover: {
        title: 'Área de Conversa',
        description:
          'Leia e envie mensagens. O histórico completo fica salvo aqui.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[data-tour="chat-message-input"]',
      popover: {
        title: 'Campo de Mensagem',
        description:
          'Digite sua mensagem, use templates ou envie arquivos.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="chat-contact-sidebar"]',
      popover: {
        title: 'Dados do Contato',
        description:
          'Veja informações do lead vinculado, histórico de interações e ações rápidas.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '[data-tour="chat-sync-btn"]',
      popover: {
        title: 'Sincronização',
        description:
          'Sincronize novas conversas do WhatsApp com o CRM.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
